<template>
  <section class="advantages" id="advantages">
    <div class="container">
      <div class="section-title">
        <h2>合作优势</h2>
        <p>携手共赢，共建智慧教育新生态</p>
      </div>
      <div class="adv-content">
        <div class="adv-list">
          <div class="adv-item" v-for="item in advantages" :key="item.id">
            <h4>
              <!-- 引入小图标 -->
              <img :src="item.icon" alt="" class="adv-icon">
              {{ item.title }}
            </h4>
            <p>{{ item.desc }}</p>
          </div>
        </div>
        <div class="adv-img">
          <img src="../assets/placeholder-img.png" alt="合作优势配图">
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AppAdvantages',
  data() {
    return {
      advantages: [
        { 
          id: 1, 
          title: '优质产品矩阵', 
          desc: '成熟稳定的产品体系，满足多样化校园场景',
          icon:  require('../assets/check-icon.png')
        },
        { 
          id: 2, 
          title: '灵活合作模式', 
          desc: '灵活合作政策，支持项目合作与区域深耕',
          icon:  require('../assets/check-icon.png') 
        },
        { 
          id: 3, 
          title: '全方位赋能支持', 
          desc: '产品培训、方案支持、技术支持',
          icon:  require('../assets/check-icon.png') 
        },
        { 
          id: 4, 
          title: '长久共赢生态', 
          desc: '完善分润体系，携手共创智慧未来',
          icon:  require('../assets/check-icon.png')
        }
      ]
    }
  }
}
</script>

<style scoped>
.advantages {
  padding: 80px 0;
  background: #fff;
}

.section-title {
  text-align: center;
  margin-bottom: 50px;
}

.section-title h2 {
  font-size: 32px;
  color: #1a1a1a;
  margin-bottom: 10px;
  font-weight: bold;
}

.section-title p {
  font-size: 16px;
  color: #666;
}

.adv-content {
  display: flex;
  align-items: center; /* 垂直居中 */
  gap: 60px;
}

.adv-list {
  flex: 1;
}

.adv-item {
  margin-bottom: 30px;
}

.adv-item h4 {
  font-size: 18px;
  color: #1a1a1a;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 10px; /* 图标与文字的间距 */
}

/* 新增：图标样式 */
.adv-icon {
  width: 24px;
  height: 24px;
  object-fit: contain;
  /* 如果你的图标是纯黑色 SVG，但想让它变成主题蓝色，可以取消下面这行注释使用 CSS 滤镜（可选） */
  /* filter: invert(38%) sepia(93%) saturate(1352%) hue-rotate(190deg) brightness(95%) contrast(96%); */
}

.adv-item p {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  /* 调整缩进：24px(图标宽) + 10px(gap) = 34px，确保文字与标题对齐 */
  padding-left: 34px; 
}

.adv-img {
  flex: 1;
  text-align: center;
}

/* 确保右侧配图不会过大 */
.adv-img img {
  max-width: 100%;
  height: auto;
  border-radius: 10px;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  /* padding: 0 20px; */
}
</style>